import React, { Component } from 'react'
import { Svg404 } from 'app/assets/icons'
import styled from 'styled-components'
import { H2 } from 'app/common/typography'
import { Link } from 'app/common/link'
import {
    ButtonMedium,
    ResponsiveContainer,
    ResponsiveDesktop,
    ResponsiveMobile
} from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { Cards } from 'app/common/cards'
import { FormattedMessage, injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import type { MarketingAnimationShortDTO } from 'shared/types'
import { Layout } from 'app/common/layout'
import type { EventMetadata } from 'shared/store/metadata'
import { eventsDefinitions } from 'shared/store/metadata'
import { Bite } from 'app/common/bite'

type Props = {
    fetchPageData: () => void,
    resetNotFoundPageData: () => void,
    secondary: Array<MarketingAnimationShortDTO>,
    sendMeta: EventMetadata => void,
    intl: IntlShape
}

class NotFound extends Component<Props> {
    componentDidMount() {
        this.props.fetchPageData()
        const metaDisplay = {
            ...eventsDefinitions['ERREUR'],
            event_action: this.props.intl.formatMessage({
                id: 'notfound.section.title'
            })
        }
        this.props.sendMeta(metaDisplay)
    }

    componentWillUnmount() {
        this.props.resetNotFoundPageData()
    }

    render() {
        const button = (
            <ButtonMedium background={colors.yellow}>
                <FormattedMessage id="notfound.button.label" />
            </ButtonMedium>
        )
        const { secondary, intl } = this.props

        const title = 'notfound.section.cards.title'

        const metaClick = {
            ...eventsDefinitions['SUGGESTION'],
            event_category: 'Erreur',
            event_label:
                intl.formatMessage({ id: 'notfound.section.title' }) + ' - '
        }

        return (
            <Layout color="white">
                <Bite />
                <Wrapper>
                    <ResponsiveDesktop>
                        <Svg404 />
                    </ResponsiveDesktop>
                    <ResponsiveMobile>
                        <Svg404 width="80%" height="40vh" />
                    </ResponsiveMobile>
                    <ResponsiveContainer>
                        <FormattedMessage id="notfound.section.title">
                            {(text: string) => <H2>{text}</H2>}
                        </FormattedMessage>
                        <Button>
                            <Link url={'/'}>{button}</Link>
                        </Button>
                    </ResponsiveContainer>
                </Wrapper>
                <Cards secondary={secondary} title={title} meta={metaClick} />
            </Layout>
        )
    }
}

const Wrapper = styled.div`
    background-color: ${colors.red2};
    text-align: center;
    padding-bottom: 75px;
    padding-top: 75px;
    ${H2} {
        color: white;
    }
`

const Button = styled.div`
    margin-top: 20px;
`

const NotFoundComponent = injectIntl(NotFound)

export { NotFoundComponent }
